import React from "react";
import "./MainWrapper.css";

type Props = {};

type State = {};

class MainWrapper extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {};
	}

	componentDidMount() {}

	render() {
		return <div className="main-wrapper">{this.props.children}</div>;
	}
}

export default MainWrapper;
